(() => {
  const root = document.querySelector('[data-help-apps-popup]');
  if (!root) return;

  const openButton = root.querySelector('[data-help-popup-open]');
  const closeButton = root.querySelector('[data-help-popup-close]');

  const slots = {
    whatsapp: root.querySelector('[data-help-native-slot="whatsapp"]'),
    ia: root.querySelector('[data-help-native-slot="ia"]'),
    brilliant: root.querySelector('[data-help-native-slot="brilliant"]'),
    callback: root.querySelector('[data-help-native-slot="callback"]'),
  };

  function queryDeep(selector, rootNode) {
    const queue = [rootNode || document];

    while (queue.length > 0) {
      const currentRoot = queue.shift();
      if (!currentRoot || typeof currentRoot.querySelector !== 'function') continue;

      const found = currentRoot.querySelector(selector);
      if (found) return found;

      const descendants = currentRoot.querySelectorAll('*');
      descendants.forEach((node) => {
        if (node.shadowRoot) queue.push(node.shadowRoot);
      });
    }

    return null;
  }

  function createProxy(slot, key, getSource, fallbackSvg, options = {}) {
    if (!slot) return;

    const { hideWhenMissing = false, preferFallbackVisual = false } = options;

    const source = getSource();

    if (!source && hideWhenMissing) {
      slot.hidden = true;
      slot.innerHTML = '';
      return;
    }

    slot.hidden = false;

    let proxy = slot.querySelector(`[data-help-proxy="${key}"]`);
    if (!proxy) {
      proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.className = 'help-apps-popup__wa-proxy';
      proxy.setAttribute('data-help-proxy', key);
      proxy.setAttribute('aria-label', `Abrir ${key}`);
      slot.innerHTML = '';
      slot.appendChild(proxy);
    }

    if (!preferFallbackVisual && source && source.innerHTML && source.innerHTML.trim()) {
      proxy.innerHTML = source.innerHTML;
    } else {
      proxy.innerHTML = fallbackSvg;
    }

    proxy.onclick = (event) => {
      event.preventDefault();
      if (key === 'callback') {
        if (openMoxieCallbackFlow()) {
          closePanel();
        }
        return;
      }
      const liveSource = getSource();
      if (liveSource) {
        // If source is an <a> tag, navigate directly to its href to bypass pointer-events: none
        if (liveSource.tagName === 'A' && liveSource.href) {
          const target = liveSource.target || '_blank';
          window.open(liveSource.href, target, 'noopener,noreferrer');
        } else {
          liveSource.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          if (typeof liveSource.click === 'function') {
            liveSource.click();
          }
        }
      }
      closePanel();
    };
  }

  function mountApps() {
    createProxy(
      slots.whatsapp,
      'whatsapp',
      () => queryDeep('#chat-bubble #whatsapp-link', document) || queryDeep('#whatsapp-link', document),
      '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.04 2.01A9.92 9.92 0 0 0 3.46 16.9L2 22l5.25-1.39a9.91 9.91 0 0 0 4.78 1.22h.01c5.47 0 9.92-4.45 9.92-9.92a9.85 9.85 0 0 0-2.9-7 9.85 9.85 0 0 0-7.02-2.9Zm5.78 14.08c-.24.69-1.43 1.27-1.98 1.35-.52.08-1.2.11-1.94-.13-.45-.15-1.03-.34-1.78-.66-3.13-1.35-5.16-4.5-5.32-4.72-.16-.22-1.27-1.7-1.27-3.25 0-1.54.81-2.3 1.1-2.62.29-.32.63-.4.84-.4h.61c.2 0 .46-.08.72.55.27.64.92 2.2 1 2.37.08.16.13.36.03.58-.1.22-.15.36-.3.55-.15.18-.31.41-.44.54-.15.15-.3.31-.13.6.17.3.75 1.24 1.62 2 .55.48 1 .79 1.33 1.02.35.22.55.19.76-.11.2-.3.87-1.02 1.1-1.37.23-.35.47-.3.78-.18.32.11 2 1 2.34 1.17.35.17.58.25.67.38.08.13.08.76-.16 1.45Z" fill="#25D366"/></svg>'
    );

    createProxy(
      slots.ia,
      'ia',
      () =>
        queryDeep('#ocular-widget-toggler', document) ||
        queryDeep('[id*="ocular-widget-toggler"]', document) ||
        queryDeep('.ocular-widget-btn', document) ||
        queryDeep('[data-ocular-widget]', document),
      '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#1D74DD"/><path d="M12 4.6L13.8 9.1L18.4 10.9L13.8 12.7L12 17.2L10.2 12.7L5.6 10.9L10.2 9.1L12 4.6Z" fill="white"/></svg>'
    );

    createProxy(
      slots.brilliant,
      'brilliant',
      () =>
        queryDeep('.bri-AssistantButton .bri-MainButton', document) ||
        queryDeep('.bri-AssistantButton', document) ||
        queryDeep('.bri-MainButton', document) ||
        queryDeep('[class*="bri-AssistantButton"]', document) ||
        queryDeep('[class*="bri-MainButton"]', document),
      '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="36" height="36" rx="10" fill="#2473D6"/><path d="M20 10V30M10 20H30M13.5 13.5L26.5 26.5M26.5 13.5L13.5 26.5" stroke="white" stroke-width="3" stroke-linecap="round"/><circle cx="13" cy="27" r="2.8" fill="white"/></svg>',
      { hideWhenMissing: true, preferFallbackVisual: true }
    );

    const callbackCustomIcon = slots.callback && slots.callback.dataset.helpSlotIcon
      ? `<img src="${slots.callback.dataset.helpSlotIcon}" width="40" height="40" alt="Te llamamos" style="width:40px;height:40px;object-fit:cover;border-radius:999px;display:block;">`
      : '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="18" fill="#00A859"/><path d="M26.44 23.64V26.34C26.44 26.84 26.24 27.31 25.89 27.66C25.54 28.01 25.07 28.21 24.57 28.21C21 28.12 17.57 26.87 14.76 24.93C12.15 23.17 10.27 20.51 11.31 17.81C11.48 17.33 11.78 16.9 12.18 16.59C12.57 16.28 13.04 16.08 13.53 16.02L15.74 15.72C16.21 15.66 16.65 15.84 16.94 16.2L18.3 18.11C18.63 18.53 18.67 19.09 18.4 19.55C18.13 20.01 17.83 20.46 17.83 20.97C17.83 21.6 18.32 22.09 18.95 22.09C19.46 22.09 19.9 21.79 20.36 21.52C20.82 21.25 21.38 21.29 21.8 21.62L23.71 22.98C24.08 23.27 24.26 23.72 24.2 24.18L23.9 26.39" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    createProxy(
      slots.callback,
      'callback',
      () => document.getElementById('moxie-floating-call-button'),
      callbackCustomIcon,
      { hideWhenMissing: true, preferFallbackVisual: true }
    );
  }

  function openMoxieCallbackFlow() {
    if (window.MoxieFloatingCallWidget && typeof window.MoxieFloatingCallWidget.openForm === 'function') {
      window.MoxieFloatingCallWidget.openForm(openPanel);
      return true;
    }
    return false;
  }

  function openPanel() {
    if (root.classList.contains('is-suspended')) return;
    root.classList.add('is-open');
    if (openButton) openButton.setAttribute('aria-expanded', 'true');
    mountApps();
  }

  function closePanel() {
    root.classList.remove('is-open');
    if (openButton) openButton.setAttribute('aria-expanded', 'false');
  }

  function isCartOverlayOpen() {
    const cartNotification = document.getElementById('cart-notification');
    const cartDrawer = document.querySelector('cart-drawer');
    const ctoDrawer = document.querySelector('.drawer--cto');

    const notificationVisible =
      !!cartNotification &&
      (cartNotification.classList.contains('active') ||
        cartNotification.classList.contains('minicart-active') ||
        (window.getComputedStyle(cartNotification).display !== 'none' &&
          window.getComputedStyle(cartNotification).visibility !== 'hidden'));

    const drawerVisible = !!cartDrawer && cartDrawer.classList.contains('active');
    const ctoDrawerVisible = !!ctoDrawer && ctoDrawer.classList.contains('active');

    return notificationVisible || drawerVisible || ctoDrawerVisible;
  }

  function syncBlockedState() {
    const shouldSuspend = isCartOverlayOpen();
    root.classList.toggle('is-suspended', shouldSuspend);
    if (shouldSuspend) closePanel();
  }

  if (openButton) {
    openButton.addEventListener('click', () => {
      const isOpen = root.classList.contains('is-open');
      if (isOpen) {
        closePanel();
        return;
      }
      openPanel();
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', closePanel);
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!root.contains(target)) closePanel();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanel();
  });

  // Lightweight refresh in case third-party widgets load late.
  let retries = 0;
  const retryTimer = setInterval(() => {
    mountApps();
    syncBlockedState();
    retries += 1;
    if (retries >= 30) {
      clearInterval(retryTimer);
    }
  }, 1000);

  // Keep help launcher hidden while cart preview/drawer overlays are open.
  const blockStateTimer = setInterval(syncBlockedState, 250);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) return;
    syncBlockedState();
  });

  mountApps();
  syncBlockedState();
})();
